import { render } from "./adminadd.vue?vue&type=template&id=7f3bb7ac&ts=true"
import script from "./adminadd.vue?vue&type=script&lang=ts"
export * from "./adminadd.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__